import { render, staticRenderFns } from "./GroupDisconnects.vue?vue&type=template&id=60c5a4b2&"
import script from "./GroupDisconnects.vue?vue&type=script&lang=ts&"
export * from "./GroupDisconnects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports